import {Swiper}        from 'swiper';
import {SwiperOptions} from 'swiper/types';

export function init() {

  let options: SwiperOptions = {
    slidesPerView : 'auto',
    spaceBetween  : 25,
    grabCursor    : true,
    freeMode      : true,
    // watchOverflow : true,
    breakpoints   : {
      992: {
        spaceBetween: 9,
      },
      700: {
        centeredSlides: true,
      }
    },
    pagination: {
      el: '.logos-carousel__pagination',
      clickable: true,
    },
  };

  new Swiper('.logos-carousel', options);
}


